/* eslint-disable */
<template>
    <div class="home">
        <div class="map-container" @click="handleCloseRoute">
            <div id="map"></div>
            <div class="top-wrapper" v-if="showBar && !showExit && poiGroups.length > 0">
                <!-- 小程序顶部筛选栏和搜索 -->
                <div class="tabbar" v-if="currentEnv">
                    <div class="search-icon" @click="handleSearch">
                        <img src="../assets/search-sentosa.svg" v-if="siteId==='1'"/>
                        <img src="../assets/search-normal.svg" v-else/>
                    </div>
                    <cube-scroll
                            class="scroll-wrapper"
                            ref="scroll"
                            direction="horizontal"
                            :data="poiGroups">
                        <div class="scroll-tab" ref="list">
                            <div class="tab"
                                :class="{'active': active === -1}"
                                @click="handleChangeTab(-1)">
                                <div class="tab-text">{{ $t('home.all') }}</div>
                            </div>
                            <div class="tab"
                                :class="{'active': active === index}"
                                v-for="(tab, index) in smallArray"
                                :key="tab.id"
                                ref="tab"
                                @click="handleChangeTab(index)">
                                <div class="tab-text">{{ tab.name }}</div>
                            </div>
                        </div>
                    </cube-scroll>
                    <div class="poi-icon" :class="{'highlight': active > 5}" @click="handleFilter">
                        <svg v-if="siteId==='1'" xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20">
                            <path fill="#222215" fill-rule="nonzero" d="M16.299.909l-2.2.07v1.894L.751 2.872H.5L.713 5.07h13.385v1.893l2.2.073V5.07H18.546l.213-2.198h-2.46V.909zM3.783 6.865V8.87h-3l.212 2.2h2.787l-.002 1.754v.024l2.2.072v-.095l.001-1.755h12.745l.213-2.2H5.981V6.793l-2.198.072zm4.874 6.325v1.682H.755l.213 2.199H8.656v2.103l2.2.072V17.07l7.873.002h.072l.213-2.19v-.01h-8.157v-1.754l-2.2.072z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                            <g fill="none" fill-rule="nonzero" stroke="#222215" stroke-linecap="round" stroke-width="1.5">
                                <path d="M6.416 8.287h16.402M6.416 14.084h16.402M6.416 19.66h16.402M20.062 5.805v4.687M10.653 11.3v4.688M15.15 17.272v4.687"/>
                            </g>
                        </svg>
                    </div>
                </div>
                <!-- 网页版搜索和tabbar -->
                <div class="tab-top" v-else>
                    <div class="search-form" @click="handleSearch">
                        <img class="search-yellow" src="@/assets/home/search-yellow.svg" />
                        <span>{{ $t('home.searchInfo') }}</span>
                    </div>
                    <cube-scroll class="web-scroll"
                                 ref="scroll"
                                 direction="horizontal"
                                 :data="poiGroups"
                                 :options="{bounce: false}">
                        <div class="web-scroll-tab" ref="list">
                            <div class="web-tab"
                                :class="{'active': active === -1}"
                                @click.stop="handleChangeTab(-1)">
                                <img v-if="active === -1" src="@/assets/home/all-selected.svg" />
                                <img v-else src="@/assets/home/all.svg" />
                                <span class="web-tab-text">{{ $t('home.all') }}</span>
                            </div>
                            <div class="web-tab"
                                :class="{'active': active === index}"
                                v-for="(tab, index) in smallArray"
                                :key="tab.id"
                                ref="tab"
                                @click.stop="handleChangeTab(index)">
                                <img v-if="active === index" :src="tab.web_icon_selected_url" />
                                <img v-else :src="tab.web_icon_url" />
                                <span class="web-tab-text">{{ tab.name }}</span>
                            </div>
                            <div class="web-tab"
                                :class="{'active': active > 5}"
                                @click="handleFilter">
                                <img v-if="active > 5" src="@/assets/home/filter-selected.svg" />
                                <img v-else src="@/assets/home/filter.svg" />
                                <span class="web-tab-text">{{ $t('home.seeMore') }}</span>
                            </div>
                        </div>
                    </cube-scroll>
                </div>
            </div>
            <!-- 之前网页有播放，现在没有再用了 -->
            <PlayBar :player="playerData" ref="player"/>
            <!-- 小程序左边的路线、演出列表、攻略入口 -->
            <div class="left-tool"
                 :class="{'show-detail': showExit}" v-if="siteId !== '129' && siteId !== '33' && currentEnv">
                <div class="navigation" v-if="!showExit">
                    <div class="route" @click.stop="handleRoute" v-if="siteId === '245'">
                        <img src="../assets/route.svg"/>
                        <div class="text">{{ $t('home.route') }}</div>
                    </div>
                    <div class="play" :class="{'rws': siteId === '245'}" @click="handlePlay">
                        <img src="../assets/strategy.svg"/>
                        <div class="text">{{ $t('home.strategy') }}</div>
                    </div>
                    <div class="show" @click="handleShow">
                        <img src="../assets/show.svg"/>
                        <div class="text">{{ $t('home.show') }}</div>
                    </div>
                </div>
                <div class="current-locate" @click="locateUser" v-if="siteId === '1'">
                    <img src="../assets/locator-sentosa-orange.svg" alt="" v-if="showLocateMarker">
                    <img src="../assets/locator-sentosa.svg" alt="" v-else>
                </div>
                <div class="current-locate" @click="locateUser" v-else>
                    <img src="../assets/zoom-in-orange.svg" alt="" v-if="showLocateMarker">
                    <img src="../assets/zoom-in.svg" alt="" v-else>
                </div>
            </div>
            <!-- 新加坡小程序右边的定位按钮、网页版的定位和导航入口 -->
            <div class="right-bar" v-if="$route.query.from !== 'CityWalk'">
                <div class="list-icon" @click="handleList" v-if="siteId == '245'">
                    <img src="../assets/list.svg" alt="">
                </div>
                <div class="singapore-locate" :class="{'web-locate': !currentEnv}" @click="locateUser" v-if="siteId === '129' || siteId === '33'">
                    <img src="../assets/zoom-in-orange.svg" alt="" v-if="showLocateMarker">
                    <img src="../assets/zoom-in.svg" alt="" v-else>
                </div>
                <div class="singapore-locate" :class="{'web-locate': !currentEnv}" @click="locateUser" v-if="(!currentEnv && siteId === '1')">
                    <img src="../assets/locator-sentosa-orange.svg" alt="" v-if="showLocateMarker">
                    <img src="../assets/locator-sentosa.svg" alt="" v-else>
                </div>
                <div class="nav-btn" :class="{'web-locate': !currentEnv}">
                    <img @click="toNavigate" src="../assets/nav-btn.svg" />
                </div>
            </div>
        </div>
        <!-- 点击poi显示的弹窗 -->
        <div v-if="popupDetail.id">
            <!-- 车站 -->
            <div class="popup station"
                 ref="popup"
                 v-if="popupDetail.type === 'site_station'">
                <div class="popup-content">
                    <div class="popup-station">
                        <div class="popup-text">
                            <div class="popup-name">{{ popupDetail.name }}</div>
                            <div class="popup-distance">{{ popupDetail.distance }}</div>
                        </div>
                        <div class="popup-btns" @click="handleNavigate">
                            <img v-if="siteId==='1'" src="/image/map-navigate-sentosa.png"/>
                            <img v-else src="/image/map-navigate.png"/>
                        </div>
                    </div>
                    <div class="bus-list" v-if="buses.length > 0">
                        <div class="bus-wrapper">
                            <div class="bus" v-for="bus in buses" :key="bus.id">
                                <div class="bus-name">{{ bus.name }}</div>
                                <!-- 按频次显示 -->
                                <div class="bus-near" v-if="bus.route_type === 'frequency'">
                                    <!-- 在运营时间内 -->
                                    <div class="bus-frequency" v-if="isOpen(bus.start_time, bus.end_time)">
                                        {{ bus.frequency }}
                                    </div>
                                    <!-- 不在运营时间内 -->
                                    <div class="time-wrapper" v-else>
                                        <div class="bus-time">
                                            <div class="time">{{ $t('home.firstBus') }}</div>
                                            <div class="label">{{ bus.start_time }}</div>
                                        </div>
                                        <div class="bus-time">
                                            <div class="time">{{ $t('home.lastBus') }}</div>
                                            <div class="label">{{ bus.end_time }}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 按下一辆车模式显示 -->
                                <div class="bus-near" v-else>
                                    <!-- 在运营时间内 -->
                                    <div class="time-wrapper" v-if="isOpen(bus.start_time, bus.end_time)">
                                        <div class="bus-frequency" v-if="bus.future_routes.length === 0">{{ $t('home.dataMissing') }}</div>
                                        <div class="bus-time" v-for="(time, index) in bus.future_routes" v-else
                                             :key="time">
                                            <div class="time">{{ index === 0 ? $t('home.nextBus') : $t('home.secondBus') }}</div>
                                            <div class="label">{{ time }}</div>
                                        </div>
                                    </div>
                                    <!-- 不在运营时间内 -->
                                    <div class="time-wrapper" v-else>
                                        <div class="bus-time">
                                            <div class="time">{{ $t('home.firstBus') }}</div>
                                            <div class="label">{{ bus.start_time }}</div>
                                        </div>
                                        <div class="bus-time">
                                            <div class="time">{{ $t('home.lastBus') }}</div>
                                            <div class="label">{{ bus.end_time }}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="bus-near" v-else>
                                  <div class="bus-time" v-for="(item, index) in bus.routes" :key="item">
                                    <div class="time">{{ item }}</div>
                                    <div class="label" v-if="bus.future_routes.length > 1">{{ index === 0 ? '首班车' : '末班车' }}</div>
                                    <div class="label" v-else>末班车</div>
                                  </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 卫生间 -->
            <div class="popup toilet"
                 ref="popup"
                 v-else-if="popupDetail.type === 'toilet' || popupDetail.type === 'site_point' || popupDetail.type === 'charge_station' || popupDetail.type === 'gateway'">
                <div class="popup-detail">
                    <div class="popup-name">{{ popupDetail.name }}</div>
                    <div class="popup-address">{{ popupDetail.distance
                        }}{{ popupDetail.distance && popupDetail.address ? ' | ' : '' }}{{ popupDetail.address }}
                    </div>
                </div>
                <div class="popup-btns" @click.stop="handleNavigate">
                    <div class="navigate-icon">
                        <img v-if="siteId==='1'" src="/image/map-navigate-sentosa.png"/>
                        <img v-else src="/image/map-navigate.png"/>
                    </div>
                </div>
            </div>
            <!-- 景点、演出等弹窗 -->
            <div class="popup" ref="popup" v-else @click="handleDetail">
                <div class="img-container">
                    <img v-if="popupDetail.images && popupDetail.images.length > 0"
                         v-lazy="generateObj(popupDetail.images[0].image)"/>
                    <img v-else-if="popupDetail.image" v-lazy="generateObj(popupDetail.image)"/>
<!--                    <img v-else-if="$route.query.from === 'CityWalk'" v-lazy="generateObj(cover_image)">-->
                    <img v-else v-lazy="generateObj(popupDetail.image_url)"/>
                </div>
                <div class="popup-detail">
                    <div class="popup-name">{{ popupDetail.name }}</div>
                    <div class="popup-tags"
                         v-if="popupDetail.labels && popupDetail.labels.length > 0 && popupDetail.type !== 'show_item'">
                        <div class="tag" v-for="item in popupDetail.labels" :key="item">{{ item.name || item }}</div>
                    </div>
                    <div class="popup-ticket" v-if="popupDetail.type === 'show_item'">
                        <span v-if="popupDetail.ticket_type === 'supported' && popupDetail.best_price !== null">{{ $t('home.ticket') }}: {{ $t('home.price', { amount: popupDetail.best_price / 100 }) }}</span>
                        <span v-else-if="popupDetail.ticket_type === 'unsupported' && popupDetail.low_price !== null">{{ $t('home.ticket') }}: {{ $t('home.price', { amount: popupDetail.low_price / 100 }) }}</span>
                        <span v-else>{{ $t('home.ticket') }}: {{ $t('home.free') }}</span>
                    </div>
                    <div class="popup-time promotion"
                         v-if="popupDetail.type === 'show_item' || popupDetail.type === 'poi_promotion'">
                        {{ popupDetail.time }}
                    </div>
                    <div class="place-rate"
                         v-if="popupDetail.rating && (popupDetail.type !== 'show_item' && popupDetail.type !== 'shop_activity' && popupDetail.type !== 'site_shop')">
                        <Score :rating="popupDetail.rating"/>
                        <div class="place-review" v-if="popupDetail.reviews">{{ popupDetail.reviews }} {{ $t('home.comment') }}</div>
                    </div>
                </div>
                <div class="popup-btns"
                     :class="{ 'with-audio' : popupDetail.audio_files && popupDetail.audio_files.length > 0 && currentEnv }">
                    <div class="play-btn"
                         @click.stop="handleJieshuo"
                         v-if="(popupDetail.type === 'site' || popupDetail.type === 'subsite') && popupDetail.audio_files && popupDetail.audio_files.length > 0 && currentEnv">
                        <img src="/image/map-jieshuo.png"/>
                    </div>
                    <div class="navigate-icon" @click.stop="handleNavigate">
                        <img v-if="siteId==='1'" src="/image/map-navigate-sentosa.png"/>
                        <img v-else src="/image/map-navigate.png"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- 定位到当前位置时，显示的箭头 -->
        <div class="current-marker" ref="marker">
            <div class="circle">
                <div class="arrow"></div>
            </div>
        </div>
        <!--城市漫步定位按钮-->
        <div class="singapore-locate locate-btn" :class="{'web-locate': !currentEnv}" @click="locateUser" v-if="isCityWalk">
            <img src="../assets/zoom-in.svg" alt="">
        </div>
        <!-- 退出路线按钮 -->
        <div class="exit-btn" @click="handleExit" v-if="showExit && !isCityWalk">{{ $t('home.exitRoute') }}</div>
        <!-- 搜索 -->
        <MapSearch ref="mapSearch" :header="header" :siteId="siteId" :poiGroups="poiGroups" @selectPoi="handleSelectPoi"/>
        <!-- 更多筛选 小程序 -->
        <PoiGroups :poiGroups="poiGroups"
                   :active="active"
                   :currentEnv="currentEnv"
                   position="top"
                   from="home"
                   ref="poiGroups"
                   @select="handleSelect"/>
        <!-- 路线列表 -->
        <MapRoute ref="mapRoute" :routes="routes" @showDetail="handleShowDetail"/>
        <!-- 路线详情 -->
        <MapRouteDetail ref="routeDetail"
                        :routes="routes"
                        :routeIndex="activeRoute"
                        @changeIndex="handleShowDetail"
                        @select="handleSelectSite"/>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
    import PlayBar from '@/components/PlayBar'
    import MapSearch from '@/components/MapSearch'
    import PoiGroups from '@/components/PoiGroups'
    import Score from '@/components/Score'
    import MapRoute from '@/components/MapRoute'
    import MapRouteDetail from '@/components/MapRouteDetail'
    import {getPoiGroups, getBus, getRoutes, getRwsGuideRouteTripDetail} from '@/fetch/api'
    import {GetDistance, pointWithinThere, formatMinutes} from '@/utils/index'
    import moment from 'moment'
    import _ from 'lodash'

    export default {
        data () {
            return {
                currentEnv: null, // 小程序环境值为miniprogram
                active: -1, // 当前点击的tab
                showBar: false,
                showPlayer: false,
                map: {},
                poiGroups: [],
                showFilter: false,
                popup: {},
                alpha: 0,
                popupDetail: { // 弹窗显示的内容
                    images: []
                },
                playerData: {},
                smallArray: [], // 展开的tab,不包含收到更多里面的
                inThere: false, // 表示是否在当地
                startGeo: {},
                buses: [],
                showLocateMarker: false,
                routes: [{points: []}],
                currentRoute: {},
                showExit: false,
                activeRoute: 0,
                typeMap: {
                    SiteStation: 'site_station',
                    Toilet: 'toilet',
                    SubSite: 'sub_site',
                    SiteFacility: 'site_facility',
                    ShowItem: 'show_item',
                    ChargeStation: 'charge_station',
                    Merchant: 'merchant',
                    Site: 'site',
                    Hotel: 'hotel',
                    Gateway: 'gateway',
                    SiteShop: 'site_shop',
                    SiteActivity: 'site_activity',
                    PoiPromotion: 'poi_promotion'
                },
                header: null,
                isCityWalk: false,
                cover_image: ''
            }
        },
        computed: {
            siteId () {
                return this.$store.state.siteId
            }
        },
        components: {
            PlayBar,
            MapSearch,
            PoiGroups,
            Score,
            MapRoute,
            MapRouteDetail
        },
        beforeDestroy () {
            if (this.busTimer) {
                clearTimeout(this.busTimer)
            }
            window.navigator.geolocation.clearWatch(this.watchId)
        },
        created () {
            // 检查网页当前运行环境
            console.log('-------rea-----')
            const currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
            if (!currentEnv) document.title = this.$t('home.pageTitle')

            this.currentEnv = currentEnv
            // 检查手机类型
            this.Android = window.navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
            // 从url读取传过来的header，给需要登录的接口
            const query = this.$route.query
            this.header = query.token ? { 'X-CLIENT-ID': query.clientId, 'X-ACCESS-TOKEN': query.token, 'X-USER-ID': query.userId } : null
            // 开始监听手机朝向变化和经纬度变化
            if (!this.isCityWalk){
                this.startUpdateLocation()
            }
            this.oldLayer = null
            console.log("LANGUAGE IS " + this.$route.query.language)
            // 地图的初始转角
            this.bearing = 0
            if (this.siteId === '245') { // rws 需要获取路线
                this.getRouteList()
            }
            this.toast = this.$createToast({
                time: 0,
                txt: this.$t('common.loadingMsg'),
                mask: true
            })
            this.toast.show()
        },
        mounted () {
            mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'
            let center = []
            let zoom = 12.6
            if (this.siteId === '245') {
                center = [103.820814, 1.255373]
                zoom = 14.5
            } else if (this.siteId === '129') {
                center = [103.861601, 1.340794]
                zoom = 9
            } else if (this.siteId === '33') {
                center = [10.372776, 51.083226]
                zoom = 5
            } else {
                center = [103.82740222, 1.2527583]
                zoom = 12.6
            }
            this.map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn', 
                center,
                zoom
                // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
            })

            // Add geolocate control to the map.
            this.geoControl = new mapboxgl.GeolocateControl({
                trackUserLocation: true
            })
            console.log('-------map--------', this.$route.query)
            if (this.$route.query.from === 'CityWalk'){
                this.isCityWalk = true
                this.getRwsGuideRoute()
            }
            this.map.on('load', () => {
                this.getPois()
            })

            this.map.on('click', () => {
                if (this.busTimer) {
                    clearTimeout(this.busTimer)
                }
            })

            this.map.on('rotate', res => {
                const alpha = this.map.getBearing()
                console.log('=======rotateend', alpha)
                this.bearing = alpha
                // // console.log('停止旋转')
                // const marker = document.querySelector('.current-marker .circle')
                // marker.style.transform = `rotateZ(${this.markerBearning - this.bearing}deg)`
            })
        },
        methods: {
            // 获取路线列表
            getRouteList () {
                // const params = this.$route.query.language === 'en' ? { locale: 'en' } : null
                getRoutes(245).then(res => {
                    this.routes = res.site_routes.map(item => {
                        item.time = formatMinutes(item.time)
                        return item
                    })
                    if (this.$route.query.routeId) {
                        const index = res.site_routes.findIndex(route => route.id === parseInt(this.$route.query.routeId))
                        console.log('route detail=====================', index)
                        this.handleShowDetail(index)
                    }
                })
            },
            handleCloseRoute () {
                if (this.$refs.mapRoute) {
                    this.$refs.mapRoute.hidePopup()
                }
                // this.$refs.routeDetail.handleClose()
            },
            // 退出路线
            handleExit () {
                this.showExit = false
                this.$refs.routeDetail.handleClose()
                if (this.oldLayer) {
                    this.map.removeLayer(this.oldLayer)
                }
                const center = this.siteId === '245' ? [103.820814, 1.255373] : [103.82740222, 1.2527583]
                const zoom = this.siteId === '245' ? 14.5 : 12.6
                this.map.flyTo({
                    center,
                    zoom
                })
                if (this.markers && this.markers.length > 0) {
                    this.markers.forEach(item => {
                        item.remove()
                    })
                }
                if (this.popup.isOpen) {
                    this.popup.remove()
                }
            },
            // 点击查看路线详情
            handleShowDetail (index) {
                if (this.popup.isOpen) {
                    this.popup.remove()
                }
                this.$refs.mapRoute.hidePopup()
                this.currentRoute = this.routes[index]
                this.activeRoute = index
                this.showExit = true
                setTimeout(()=>{
                    this.$refs.routeDetail.handleShow()
                    this.drawTripRoute()
                    this.toast.hide()
                }, 2 * 1000)

                // this.$nextTick(() => {
                //     this.$refs.routeDetail.handleShow()
                //     this.drawTripRoute()
                // })
            },
            // 在地图上绘制行程路线
            drawTripRoute () {
                if (this.currentRoute.points.length === 0) return
                const coordinates = this.currentRoute.points.map(item => {
                    return [item.lon, item.lat]
                })
                if (this.oldLayer) {
                    this.map.removeLayer(this.oldLayer)
                    this.map.removeSource(this.oldLayer)
                }
                this.map.addLayer({
                    'id': 'route',
                    'type': 'line',
                    'source': {
                        'type': 'geojson',
                        'data': {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'LineString',
                                'coordinates': coordinates
                            }
                        }
                    },
                    'layout': {
                        'line-cap': 'round',
                        'line-join': 'round'
                    },
                    'paint': {
                        'line-width': 3,
                        'line-color': '#f8a909',
                        'line-dasharray': [0.6, 2]
                    }
                })
                this.oldLayer = 'route'
                const bounds = this.calcLonLat()
                // console.log('bounds', bounds)
                this.map.fitBounds(bounds, {
                    padding: {
                        top: 60,
                        bottom: 190,
                        left: 90,
                        right: 60
                    }
                })
                this.drawMarker()
            },
            // 计算[sw, ne], 用于地图fitBounds控制显示范围
            calcLonLat () {
                let minLon = this.currentRoute.points[0].lon
                let minLat = this.currentRoute.points[0].lat
                let maxLon = this.currentRoute.points[0].lon
                let maxLat = this.currentRoute.points[0].lat
                this.currentRoute.points.forEach(item => {
                    if (item.lon < minLon) {
                        minLon = item.lon
                    } else if (item.lon > maxLon) {
                        maxLon = item.lon
                    }
                    if (item.lat < minLat) {
                        minLat = item.lat
                    } else if (item.lat > maxLat) {
                        maxLat = item.lat
                    }
                })
                return [[minLon, minLat], [maxLon, maxLat]]
            },
            // 在地图上绘出路线中的各个点
            drawMarker () {
                // 删除旧的marker
                if (this.markers && this.markers.length > 0) {
                    this.markers.forEach(item => {
                        item.remove()
                    })
                }
                let markers = []
                this.currentRoute.points.forEach((item, current) => {
                    // create a DOM element for the marker
                    const el = document.createElement('div')
                    el.className = 'marker'
                    el.innerText = current + 1
                    el.style.width = '24px'
                    el.style.height = '24px'
                    el.style.borderRadius = '50%'
                    el.style.border = '2px solid #ffffff'
                    el.style.backgroundColor = '#ffd225'
                    el.style.display = 'flex'
                    el.style.alignItems = 'center'
                    el.style.justifyContent = 'center'
                    el.style.fontSize = '14px'
                    el.style.color = '#222125'

                    el.addEventListener('click', (e) => {
                        e.stopPropagation()
                        this.popupDetail = {
                            ...item,
                            type: this.isCityWalk? item.point_type : 'subsite'
                        }
                        this.$nextTick(() => {
                            this.initPopup({
                                geometry: {
                                    coordinates: [item.lon, item.lat]
                                }
                            }, {lon: item.lon, lat: item.lat})
                        })
                    })

                    // add marker to map
                    const marker = new mapboxgl.Marker(el)
                        .setLngLat([item.lon, item.lat])
                        .addTo(this.map)
                    markers.push(marker)
                })
                this.markers = markers
            },
            // 点击路线中的某一个景点
            handleSelectSite (site) {
                // console.log('点击路线信息', site)
                this.popupDetail = {
                    ...site,
                    type: this.typeMap[site.type]
                }
                this.$nextTick(() => {
                    this.initPopup({
                        geometry: {
                            coordinates: [site.lon, site.lat]
                        }
                    }, {lon: site.lon, lat: site.lat})
                })
            },
            // 根据不同的小程序，返回不同的默认图，给v-lazy
            generateObj (src) {
                let url = '/image/default_img.jpg'
                if (this.siteId === '245' || this.siteId === '129') {
                    url = '/image/rws_default.jpg'
                } else if (this.siteId === '33') {
                    url = '/image/default_porsche.jpg'
                }
                return {
                    src,
                    error: url,
                    loading: '/image/loading-img.jpg'
                }
            },
            getRwsGuideRoute(){
                getRwsGuideRouteTripDetail(this.$route.query.id).then((res)=>{
                    this.routes = [res.guide_route]
                    this.routes[0].play_time = formatMinutes(this.routes[0].play_time)
                    this.cover_image = res.cover_image_url
                    this.routes[0].name = res.name
                    this.handleShowDetail(0)
                })
            },
            // 获取poiGroups
            getPois () {
                let longitude = ''
                let latitude = ''
                let params = this.$route.query.language === 'zh' ? { locale: 'cn' } : { locale: 'en' }
                getPoiGroups(this.siteId, params).then(res => {
                    const poiGroups = JSON.parse(JSON.stringify(res.poi_groups))
                    // let NewData = JSON.parse(JSON.stringify(poiGroups))
                    this.showBar = true
                    // this.processPoiGroups(poiGroups, 103.826649, 1.24865)
                    // wx.getLocation({
                    //   type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    //   success: (res) => {
                    //     alert(JSON.stringify(res))
                    //     this.processPoiGroups(poiGroups, res.longitude, res.latitude)
                    //   },
                    //   fail: err => {
                    //     alert(JSON.stringify(err))
                    //     this.processPoiGroups(poiGroups, null, null)
                    //   }
                    // })
                    this.processPoiGroups(poiGroups, '', '')
                    // window.navigator.geolocation.getCurrentPosition((res) => {
                    //   console.log('获取地理位置成功')
                    // }, err => {
                    //   console.log('获取地理位置失败', err)
                    //   this.processPoiGroups(poiGroups, 103.826649, 1.24865)
                    //   this.startGeo = {
                    //     lon: 103.826649,
                    //     lat: 1.24865
                    //   }
                    // })
                })
            },
            // 只处理数据
            handlePois (res, longitude, latitude) {
                // res.sort((a, b) => {
                //     if (a.poi_type !== 'site' && b.poi_type !== 'site') {
                //         return b.rank - a.rank
                //     } else if (b.poi_type === 'site') {
                //         return -1
                //     }
                // })
                res.forEach(poiGroup => {
                    poiGroup.pois.forEach(item => {
                        let distance = ''
                        if (longitude) {
                            distance = GetDistance(latitude, longitude, item.lat, item.lon)
                        }
                        item.distance = distance
                        if (item.labels) {
                            item.labels = item.labels.slice(0, 3)
                        }

                        // 处理车次信息
                        if (poiGroup.poi_type === 'site_station' && item.station_routes.length > 0) {
                            item.station_routes = item.station_routes.filter(route => {
                                if (this.siteId === '1') { // 圣淘沙使用频次模式，其他使用下一辆模式
                                    return route.route_type === 'frequency'
                                } else {
                                    return route.route_type === 'next'
                                }
                            })
                        }
                    })
                    this.poiGroups = res
                    this.smallArray = res.slice(0, 6)
                })
            },
            processPoiGroups (res, longitude, latitude) {
                this.handlePois(res, longitude, latitude)
                const promiseArray = res.map(current => {
                    return this.loadImages(current)
                })
                Promise.all(promiseArray).then(resArray => {
                    this.renderLayer(res)
                    if (this.$route.query.from !== 'CityWalk'){
                        this.toast.hide()
                    }
                })
            },
            // 渲染所有的poi groups
            renderLayer (res) {
                // 排序，大poi排在最后，绘出来的层级高
                const sortedArray = _.cloneDeep(res).sort((a, b) => {
                    if (a.poi_type === 'site_station' || a.poi_type === 'site_point' || a.poi_type === 'toilet') {
                        return -1
                    }
                    if (b.poi_type === 'site_station' || b.poi_type === 'site_point' || b.poi_type === 'toilet') {
                        return 1
                    }
                })
                let zoom = 12.6
                if (this.siteId === '245') {
                    zoom = 14.5
                } else if (this.siteId === '129') {
                    zoom = 9
                } else if (this.siteId === '33') {
                    zoom = 5
                }

                sortedArray.forEach(poiGroup => {
                    const features = poiGroup.pois.map((item, index) => {
                        const name = item.name.replace(/[\r\n]/g, '')
                        return {
                            type: 'Feature',
                            properties: {
                                poiIndex: index,
                                icon: poiGroup.poi_type,
                                name: name
                            },
                            geometry: {
                                type: 'Point',
                                coordinates: [item.lon, item.lat]
                            }
                        }
                    })
                    const expression = this.calcExpression()

                    this.map.addLayer({
                        id: `${poiGroup.poi_type}_${poiGroup.id}`,
                        type: 'symbol',
                        source: {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: features
                            }
                        },
                        layout: {
                            'icon-image': `${poiGroup.poi_type}_${poiGroup.id}`,
                            'icon-size': expression.iconSize,
                            'icon-anchor': poiGroup.poi_type === 'site_image' ? 'bottom' : 'center',
                            'text-field': ['get', 'name'],
                            'text-anchor': 'left',
                            'text-justify': 'center',
                            'text-offset': [1.5, 0],
                            'text-size': [
                                'interpolate', ['linear'], ['zoom'],
                                13, 0,
                                14, 8,
                                20, 12
                            ]
                        },
                        paint: {
                            'text-color': '#222125',
                            'icon-opacity': expression.iconOpacity,
                            'text-opacity': [
                                'interpolate', ['linear'], ['zoom'],
                                14, 0,
                                15, 0.5,
                                20, 1
                            ]
                        }
                    })
                    // 点击layer显示popup
                    this.map.on('click', `${poiGroup.poi_type}_${poiGroup.id}`, e => {
                        const feature = e.features[0]
                        const lngLat = e.lngLat
                        const poiIndex = parseInt(feature.properties.poiIndex)
                        const currentPoi = poiGroup.pois[poiIndex]
                        if (poiGroup.poi_type === 'site_image') { // 360全景图片直击跳转详情页面
                            if (this.currentEnv) {
                                window.wx.miniProgram.navigateTo({
                                    url: `/packageScenic/pages/360Image/index?name=${currentPoi.name}&url=${currentPoi.image_url}`
                                })
                            } else {
                                let url = `/360Image?name=${currentPoi.name}&url=${currentPoi.image_url}`
                                if (this.$route.query.language === 'zh') url += '&language=zh'
                                this.$router.push(url)
                            }
                        } else { // 点击车站类型的poi需要请求车次信息
                            this.popupDetail = {...currentPoi, type: poiGroup.poi_type}
                            if (poiGroup.poi_type === 'site_station') {
                                if (this.busTimer) {
                                    clearTimeout(this.busTimer)
                                }
                                this.getBusList(feature, currentPoi, lngLat, true)
                            } else {
                                this.$nextTick(() => {
                                    this.initPopup(feature, lngLat)
                                })
                            }
                        }
                    })
                })
            },
            // 图标大小和透明度和地图缩放等级zoom的表达式
            calcExpression () {
                let iconSize = [
                    'interpolate', ['linear'], ['zoom'],
                    9, 0.26,
                    18, 0.4
                ]
                let iconOpacity = [
                    'interpolate', ['linear'], ['zoom'],
                    9, 0.4,
                    12.6, 1,
                ]
                if (this.siteId === '129') { // 新加坡
                    iconSize = [
                        'interpolate', ['linear'], ['zoom'],
                        9, 0.26,
                        18, 0.46
                    ]
                    iconOpacity = [
                        'interpolate', ['linear'], ['zoom'],
                        9, 0.4,
                        18, 1
                    ]
                } else if (this.siteId === '33') { // 德国
                    iconSize = [
                        'interpolate', ['linear'], ['zoom'],
                        5, 0.24,
                        18, 0.46
                    ]
                    iconOpacity = [
                        'interpolate', ['linear'], ['zoom'],
                        5, 0.4,
                        18, 1
                    ]
                }
                return { iconSize, iconOpacity }
            },
            // init popup
            initPopup (feature, lngLat) {
                console.log('点击弹窗触发', feature)
                if (this.popup.isOpen) {
                    this.popup.remove()
                }
                const coordinates = feature.geometry.coordinates.slice()

                while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360
                }

                this.popup = new mapboxgl.Popup()
                    .setLngLat(coordinates)
                    .setDOMContent(this.$refs.popup)
                    .addTo(this.map)

                this.map.flyTo({center: feature.geometry.coordinates})
            },
            // 点击popup跳转到detail页面
            toDetail (id) {
                this.$router.push(`/detail/${id}`)
            },
            // 加载所有图片
            loadImages (poiGroup) {
                return new Promise((resolve, reject) => {
                    this.map.loadImage(poiGroup.image_url, (error, image) => {
                        // console.log(error, image)
                        if (error) {
                            reject(error)
                        } else {
                            this.map.addImage(`${poiGroup.poi_type}_${poiGroup.id}`, image)
                            resolve()
                        }
                    })
                })
            },
            // 返回当前时间是否在运营时间内
            isOpen (start_hour, end_hour) {
                const today = moment().format('YYYY-MM-DD')
                const tomorrow = moment().subtract(-1, 'days').format('YYYY-MM-DD')
//                console.log('oooooooooooooooooooooo')
//                console.log(start_hour)
//                console.log(end_hour)
//                start_hour='15:30'
                //当天
                if (this.compareHours(start_hour, end_hour)) {
                    console.log('当天开始当天结束');
                    return moment().isBetween(`${today} ${start_hour}`, `${today} ${end_hour}`)
                } else {
                    console.log('当天开始第二天结束');
//                    console.log(`${today} ${start_hour}`);
//                    console.log(`${tomorrow} ${end_hour}`);
//                    console.log(moment().isBetween(`${today} ${start_hour}`, `${tomorrow} ${end_hour}`))
                    return moment().isBetween(`${today} ${start_hour}`, `${tomorrow} ${end_hour}`);
                }
            },
//            对比开始时间和结束时间是否为当天
            compareHours(start, end){
                let date = new Date();
                let a = start.split(":");
                let b = end.split(":");
//              开始时间小于结束时间 ： 当天
//                console.log('开始的时间:' + date.setHours(a[0], a[1]))
//                console.log('结束的时间:' + date.setHours(b[0], b[1]))
                return date.setHours(a[0], a[1]) < date.setHours(b[0], b[1]);
            },
            // 获取公交车时间
            getBusList (feature, currentPoi, lngLat, loading) {
                if (loading) {
                    this.toast = this.$createToast({
                        time: 0,
                        txt: this.$t('common.loadingMsg')
                    })
                    this.toast.show()
                }
                const params = this.$route.query.language === 'zh' ? { locale: 'cn' } : { locale: 'en' }
                // 一分钟请求一次车次信息
                getBus(currentPoi.id, params).then(res => {
                    // 过滤车次
                    res.station_routes = res.station_routes.filter(route => {
                        if (this.siteId === '1') { // 圣淘沙使用频次模式，其他使用下一辆模式
                            return route.route_type === 'frequency'
                        } else {
                            return route.route_type === 'next'
                        }
                    })
                    if (loading) {
                        this.toast.hide()
                    }
                    this.buses = res.station_routes
                    this.$nextTick(() => {
                        this.initPopup(feature, lngLat)
                        this.busTimer = setTimeout(() => {
                            this.getBusList(feature, currentPoi, lngLat)
                        }, 60000)
                    })
                })
            },
            // 显示所有的layer
            showAll () {
                this.categories.forEach(item => {
                    this.map.setLayoutProperty(item, 'visibility', 'visible')
                })
                this.showFilter = false
            },
            // 显示搜索弹窗
            handleSearch () {
                this.$refs.mapSearch.show()
                setTimeout(() => {
                    this.$refs.poiGroups.hide()
                }, 300)
            },
            // 路线
            handleRoute () {
                this.handleExit()
                if (this.routes.length > 0) {
                    this.$refs.mapRoute.displayPopup()
                } else {
                    this.toast = this.$createToast({
                        time: 3000,
                        type: 'txt',
                        txt: this.$t('home.noRoute')
                    })
                    this.toast.show()
                }
            },
            // 点击攻略icon
            handlePlay () {
                window.wx.miniProgram.navigateTo({
                    // url: '/packageScenic/pages/playPage/home/index',
                    url: '/packageTourGuide/site/siteGuidePage/index'
                })
            },
            // 点击演出列表
            handleShow () {
                window.wx.miniProgram.navigateTo({
                    url: '/packageTourGuide/show/showPage/home/index'
                    // url: '/packageScenic/pages/showPage/home/index'
                })
            },
            // 限时poigroups
            handleFilter () {
                this.$refs.poiGroups.show(this.currentEnv)
            },
            handleList () {
                window.wx.miniProgram.navigateTo({
                    url: '/pages/scenic/onlineTour/home/index'
                })
            },
            // 设置active tab
            handleChangeTab (index) {
                if (this.popup.isOpen) {
                    this.popup.remove()
                    if (this.busTimer) {
                        clearTimeout(this.busTimer)
                    }
                }
                if (index === -1) { // 全部显示
                    this.poiGroups.forEach(item => {
                        this.map.setLayoutProperty(`${item.poi_type}_${item.id}`, 'visibility', 'visible')
                    })
                } else {
                    const poiGroup = this.poiGroups[index]
                    // const zoom = this.map.getZoom()
                    // 过滤layer
                    // 需要被隐藏的layerid数组
                    const layerId = `${poiGroup.poi_type}_${poiGroup.id}`
                    // 根据选择的poigroup type 筛选地图上的点
                    this.poiGroups.forEach(item => {
                        if (`${item.poi_type}_${item.id}` === layerId) {
                            this.map.setLayoutProperty(`${item.poi_type}_${item.id}`, 'visibility', 'visible')
                        } else {
                            this.map.setLayoutProperty(`${item.poi_type}_${item.id}`, 'visibility', 'none')
                        }
                    })
                }
                this.active = index
            },
            // 点击搜索结果
            handleSelectPoi (data) {
                // console.log('搜索poi', data)
                this.popupDetail = {
                    ...data.poi,
                    type: data.type
                }
                const groupId = data.groupId
                this.$nextTick(() => {
                    this.map.setZoom(16)
                    // 显示搜索结果的poiGroup
                    this.poiGroups.forEach(item => {
                        if (item.poi_type === data.type && item.id === groupId) {
                            this.map.setLayoutProperty(`${item.poi_type}_${item.id}`, 'visibility', 'visible')
                        } else {
                            this.map.setLayoutProperty(`${item.poi_type}_${item.id}`, 'visibility', 'none')
                        }
                    })
                    const feature = {
                        geometry: {
                            coordinates: [data.poi.lon, data.poi.lat]
                        }
                    }
                    const lngLat = {lon: data.poi.lon, lat: data.poi.lat}
                    if (data.type === 'site_station') {
                        if (this.busTimer) {
                            clearTimeout(this.busTimer)
                        }
                        this.getBusList(feature, data.poi, lngLat, true)
                    } else {
                        this.$nextTick(() => {
                            this.initPopup(feature, lngLat)
                        })
                    }
                })
            },
            // 点击解说按钮
            handleJieshuo () {
                // this.playerData = { ...this.popupDetail.audio_files[0], siteId: this.popupDetail.id }
                // this.$store.commit('SET_AUDIO_URL', this.popupDetail.audio_files[0].audio_url)
                // this.$emit('play')
                // this.$refs.player.show()
                if (this.popupDetail.type === 'site') {
                    window.wx.miniProgram.navigateTo({
                        url: `/packageScenic/pages/audioList/index?id=${this.popupDetail.id}`
                    })
                } else {
                    window.wx.miniProgram.navigateTo({
                        url: `/packageScenic/pages/subSiteDetail/index?id=${this.popupDetail.id}&type=subsite`
                    })
                }
            },
            // 点击导航按钮
            handleNavigate () {
                // [start_lon, start_lat, start_name, start_type, start_id, end_lon, end_lat, end_name, end_type, end_id]
                let routeArray = []
                const endType = this.popupDetail.type.split('_').map(item => {
                    const type = item.slice(0, 1).toUpperCase() + item.slice(1)
                    return type
                }).join('')
                routeArray = ['', '', '', '', '', parseFloat(this.popupDetail.lon), parseFloat(this.popupDetail.lat), this.popupDetail.name, endType, this.popupDetail.id]
                console.log(`/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`)
                if (this.currentEnv) { // 小程序环境下跳转小程序页面
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/map/navigationMapPage/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
                        // url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
                    })
                } else {
                    // ios13. safari需要请求获取朝向的权限
                    this.askForPermission()
                    // routeArray = [104.0608, 30.5812, '楚峰国际', '', '', 104.0587, 30.5796, '奥克斯广场', '', '']
                    if (this.header) {
                        this.header['X-CLIENT-ID'] && routeArray.push(this.header['X-CLIENT-ID'])
                        this.header['X-ACCESS-TOKEN'] && routeArray.push(this.header['X-ACCESS-TOKEN'])
                        this.header['X-USER-ID'] && routeArray.push(this.header['X-USER-ID'])
                    }
                    let url = `/navigateweb/${encodeURIComponent(JSON.stringify(routeArray))}?siteId=${this.siteId}`
                    if (this.$route.query.language === 'zh') url += '&language=zh'
                    this.$router.push(url)
                }
            },
            // 查看景点详情
            handleDetail () {
                let id = this.popupDetail.id
                if (this.isCityWalk){
                    id = this.popupDetail.point_id
                }
                const type = this.popupDetail.type.toLowerCase()
                switch (type) {
                    case 'site':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageTourGuide/site/siteDetailPage/index?id=${id}`
                                // url: `/packageScenic/pages/siteDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/siteDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'subsite':
                        window.wx.miniProgram.navigateTo({
                            url: `/packageTourGuide/site/subSiteDetailPage/index?id=${id}`
                        })
                        break
                    case 'merchant':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageTourGuide/otherPOI/restaurantDetailPage/index?id=${id}`
                                // url: `/packageScenic/pages/merchantDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/merchantDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'hotel':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageTourGuide/hotel/hotelDetailPage/index?id=${id}`
                                // url: `/packageScenic/pages/hotelDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/hotelDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'show_item':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageScenic/pages/showDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/showDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'site_shop':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageScenic/pages/mallDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/mallDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'site_activity':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageScenic/pages/eventDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/eventDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    case 'poi_promotion':
                        if (this.currentEnv) {
                            window.wx.miniProgram.navigateTo({
                                url: `/packageScenic/pages/promotionDetail/index?id=${id}`
                            })
                        } else {
                            let url = `/promotionDetail/${id}`
                            if (this.$route.query.language === 'zh') url += '?language=zh'
                            this.$router.push(url)
                        }
                        break
                    default:
                        break
                }
            },
            handleSelect (index) {
                // console.log(index)
                if (index === -1) {
                    this.handleChangeTab(-1)
                    this.$refs.scroll.scrollTo(0, 0)
                } else {
                    this.handleChangeTab(index)
                    if (index >= 6) return
                    let left = this.$refs.tab[index].offsetLeft
                    const totalWidth = this.$refs.list.clientWidth
                    const tabWidth = this.$refs.tab[index].clientWidth
                    const windowWidth = window.innerWidth
                    const offset = this.currentEnv ? 76 : 0
                    // console.log(left, totalWidth, tabWidth)
                    if (left > totalWidth - windowWidth + offset) {
                        left = totalWidth - windowWidth + offset
                    } else if (left <= tabWidth) {
                        left = tabWidth
                    }
                    // console.log(left)
                    // if (index < 2) {
                    //   const left = this.$refs.tab[index].offsetLeft
                    this.$refs.scroll.scrollTo(-left, 0)
                    // }
                }
            },
            // 获取角度、位置信息
            startUpdateLocation () {
                if (this.Android) {
                    window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
                } else {
                    window.addEventListener('deviceorientation', this.handleOrientation)
                }
                this.watchId = window.navigator.geolocation.watchPosition((res) => {
                    // console.log(longitude, latitude)
                    const longitude = res.coords.longitude
                    const latitude = res.coords.latitude
                    const inThere = pointWithinThere(longitude, latitude)
                    if (inThere && this.startGeo && !this.startGeo.lon) { // 在圣淘沙并且第一次获取到位置
                        this.inThere = true
                        this.map.flyTo({
                            center: [longitude, latitude],
                            zoom: 15
                        })
                        if (!this.currentMarker) {
                            this.drawCurrentMarker(longitude, latitude)
                        }
                    }
                    if (this.poiGroups.length > 0) {
                        this.handlePois(this.poiGroups, longitude, latitude)
                    }
                    if (longitude) {
                        this.startGeo = {
                            lon: longitude,
                            lat: latitude
                        }
                        if (this.currentMarker) {
                            this.currentMarker.setLngLat([longitude, latitude])
                            this.currentMarker.addTo(this.map)
                        }
                        this.inThere = inThere
                    }
                }, err => {
                }, {timeout: 20000, enableHighAccuracy: true})
            },
            // ios 朝向变化回调
            handleOrientation (res) {
                // console.log('旋转收到的数据', res)
                const alpha = res.webkitCompassHeading
                // console.log('获取到的数据', alpha)
                // alert(`收到数据alpha: ${alpha}`)
                this.alpha = alpha
                this.deviceOrientationHandler(alpha)
            },
            // 安卓朝向变化回调
            handleOrientationAbsolute (res) {
                const alpha = 360 - res.alpha
                // console.log('获取到的数据', alpha)
                this.alpha = alpha
                this.deviceOrientationHandler(alpha)
            },
            // 根据朝向变化，改版箭头指向
            deviceOrientationHandler (alpha) {
                // console.log('收到的角度', alpha)
                if (!this.currentMarker) return
                // console.log('有marker')
                const marker = document.querySelector('.current-marker .circle')
                // console.log(marker, alpha)
                // console.log('当前的marker', marker)
                marker.style.transform = `rotateZ(${alpha - this.bearing}deg)`
            },
            // 添加当前位置marker
            drawCurrentMarker (longitude, latitude) {
                // add marker to map
                this.showLocateMarker = true
                const marker = new mapboxgl.Marker(this.$refs.marker)
                    .setLngLat([longitude, latitude])
                    .addTo(this.map)
                this.currentMarker = marker
            },
            // 点击按钮定位到当前位置
            locateUser () {
                if (!this.inThere) {
                    let text = ''
                    if (this.siteId === '245') {
                        text = this.$t('navigate.notInRws')
                    } else if (this.siteId === '129') {
                        text = this.$t('navigate.notInSingapore')
                    } else if (this.siteId === '33') {
                        text = this.$t('navigate.notInGermany')
                    } else {
                        text = this.$t('navigate.notInSentosa')
                    }
                    this.toast = this.$createToast({
                        time: 1500,
                        type: 'txt',
                        txt: text
                    })
                    this.toast.show()
                    return
                }
                this.askForPermission()
                if (this.startGeo && this.startGeo.lon) {
                    if (!this.currentMarker) {
                        this.drawCurrentMarker(this.startGeo.lon, this.startGeo.lat)
                    }
                    this.map.panTo([this.startGeo.lon, this.startGeo.lat])
                } else {
                    this.toast = this.$createToast({
                        time: 1500,
                        type: 'txt',
                        txt: this.$t('navigate.errorMsg')
                    })
                    this.toast.show()
                }
            },
            // 点击跳转到导航页面
            toNavigate () {
                const routeArray = ['', '', '', '', '', '', '', '', '', '']
                if (this.currentEnv) {
                    window.wx.miniProgram.navigateTo({
                        // url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
                        url: `/packageTourGuide/map/navigationMapPage/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
                    })
                } else {
                    this.askForPermission()
                    if (this.header) {
                        this.header['X-CLIENT-ID'] && routeArray.push(this.header['X-CLIENT-ID'])
                        this.header['X-ACCESS-TOKEN'] && routeArray.push(this.header['X-ACCESS-TOKEN'])
                        this.header['X-USER-ID'] && routeArray.push(this.header['X-USER-ID'])
                    }
                    let url = `/navigateweb/${encodeURIComponent(JSON.stringify(routeArray))}?siteId=${this.siteId}`
                    if (this.$route.query.language === 'zh') url += '&language=zh'
                    this.$router.push(url)
                }
            },
            askForPermission () {
                console.log('询问是否允许使用方向')
                // ios 13
                if (typeof DeviceOrientationEvent.requestPermission === 'function') {
                    DeviceOrientationEvent.requestPermission().then(permissionState => {
                        console.log('======permissionState==================', permissionState)
                        if (permissionState === 'granted') {
                            // window.addEventListener('deviceorientation', this.handleOrientation)
                        }
                    }).catch(err => {
                        console.log('permission error', err)
                        this.toast = this.$createToast({
                            time: 1500,
                            type: 'txt',
                            txt: this.$t('common.orientationMsg')
                        })
                        this.toast.show()
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .home {
        height: 100vh;
        position: relative;
        overflow: hidden;
    }

    #map {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }

    .tabbar {
        position: absolute;
        top: -1px;
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: space-between;
        z-index: 3100;

        .scroll-wrapper {
            width: calc(100% - 76px);
            height: 40px;
        }

        .scroll-tab {
            white-space: nowrap;
        }

        .list-wrapper {
            padding: 0 10px;
            line-height: 60px;
        }

        .tab {
            display: inline-block;
            padding: 9px 17px;
            position: relative;
            &:after {
                content: '';
                width: 32px;
                height: 4px;
                background-color: #f8a909;
                position: absolute;
                bottom: 16px;
                left: 50%;
                margin-left: -16px;
                transform: scale(0);
                transition: transform 0.2s ease-out;
                z-index: 0;
            }

            &.active {
                .tab-text {
                    font-weight: bold;
                    font-family: GothamBold;
                    color: #222125;
                }

                &:after {
                    transform: scale(1);
                }
            }
        }

        .tab-text {
            font-size: 16px;
            white-space: nowrap;
            line-height: 22px;
            color: #888888;
            position: relative;
            top: -4px;
            z-index: 1;
            transition: all 0.2s ease-out;
        }

        .search-icon,
        .poi-icon {
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0 5px;
            background-color: #ffffff;
            flex-shrink: 0;
            position: relative;
        }

        .poi-icon.highlight {
            svg g {
                stroke: #f8a909;
            }

            svg path {
                fill: #f8a909;
            }
        }

        .search-icon {
            padding: 0 5px 0 12px;
            &:before {
                content: '';
                width: 20px;
                height: 40px;
                position: absolute;
                top: 0;
                left: 100%;
                z-index: 5;
                background-image: linear-gradient(to right, #ffffff, rgba(255, 255, 255, 0));
            }
        }

        .poi-icon {
            left: auto;
            right: 0;
            &:before {
                content: '';
                width: 20px;
                height: 40px;
                position: absolute;
                top: 0;
                right: 100%;
                z-index: 5;
                background-image: linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0));
            }
        }
    }

    .map-container {
        position: relative;
    }

    .navigation {
        background-color: #ffffff;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
        border-radius: 19px;
        margin-bottom: 13px;
        width: 38px;

        .text {
            font-size: 11px;
            color: #222125;
            font-weight: bold;
            font-family: GothamBold;
            line-height: 16px;
        }

        img {
            display: block;
            margin: 0 auto 3px;
        }
        .route {
            padding: 13px 7px 5px
        }
        .play {
            padding: 13px 7px 5px;

            &.rws {
                padding-top: 5px;
            }
        }
        .show {
            padding: 5px 7px 13px;
        }
    }

    .left-tool {
        position: absolute;
        left: 18px;
        z-index: 10;
        bottom: 18px;

        &.show-detail {
            bottom: 195px;
        }
    }

    .current-locate {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 30;

        img {
            width: 25px;
            height: 26px;
        }
    }

    .right-bar {
        position: fixed;
        z-index: 10;
        top: auto;
        bottom: 18px;
        right: 12px;
        margin-bottom: env(safe-area-inset-bottom);
        .list-icon {
            img {
                display: block;
            }
        }

        .nav-btn {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background-color: #ffffff;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
            margin: 14px 2px 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;

            &.web-locate {
                width: 48px;
                height: 48px;

                img {
                    width: 20px;
                }
            }

            img {
                display: block;
                position: relative;
                left: 2px;
            }
        }

        .singapore-locate {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;

            &.web-locate {
                width: 48px;
                height: 48px;

                img {
                    width: 24px;
                    left: 0;
                }
            }

            img {
                position: relative;
                left: -1px;
            }
        }
    }


    .current-marker {
        z-index: 20;
        transform: translate(-9999px, -9999px);
        .circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: url('/image/navigate/current-marker.svg') no-repeat center center;
            z-index: 2;
            position: relative;
            background-size: 100% 100%;
        }

        .arrow {
            position: absolute;
            border: 5px solid transparent;
            border-bottom: 5px solid #00AAE5;
            bottom: 100%;
            left: 50%;
            margin-left: -5px;
            margin-bottom: -2px;
            // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        }
    }

    .locate-btn{
        position: absolute;
        bottom: 195px;
        left: 19px;
        border-radius: 50%;
        background-color: #ffffff;
        font-size: 14px;
        line-height: 1em;
        width: 38px;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        object-fit: contain;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
    }
    .exit-btn {
        position: absolute;
        bottom: 195px;
        right: 12px;
        width: 90px;
        height: 30px;
        border-radius: 15px;
        box-shadow: 0 2px 2px 0 rgba(34, 33, 37, 0.2);
        background-color: #ffffff;
        font-size: 14px;
        line-height: 1em;
        color: #ffa400;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tab-top {
        position: fixed;
        top: 12px;
        left: 0;
        width: 100%;

        .search-form {
            display: flex;
            align-items: center;
            margin: 0 12px;
            border-radius: 4px;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            padding: 0 12px;
            height: 42px;

            img {
                width: 17px;
                height: 18px;
                display: block;
                flex-shrink: 0;
                margin-right: 5px;
            }

            span {
                font-size: 15px;
                color: #888888;
            }
        }
    }

    .web-scroll {
        width: 100%;
        margin-top: 10px;

        &-tab {
            white-space: nowrap;
        }

        .web-tab {
            display: inline-flex;
            padding: 0 12px 0 32px;
            height: 30px;
            border-radius: 15px;
            position: relative;
            background-color: #ffffff;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
            margin-right: 10px;
            align-items: center;
            position: relative;

            &:first-child {
                margin-left: 12px;
            }

            &:last-child {
                margin-right: 12px;
            }

            img {
                margin-right: 4px;
                width: 16px;
                position: absolute;
                left: 12px;
                top: 50%;
                transform: translateY(-50%);
            }

            &-text {
                font-size: 14px;
                color: #666666;
            }

            &.active {
                background-color: #f7bf00;
                .web-tab-text {
                    color: #ffffff;
                }
            }
        }
    }
</style>
